import React from "react";
import { useNavigate } from "react-router-dom";
import { CTA } from "../mock";
import { Eyebrow } from "./Hero";

export default function NextMoves() {
  const navigate = useNavigate();
  return (
    <section data-testid="final-cta-section" className="relative isolate overflow-hidden py-16 md:py-20 sep-top">
      <div className="relative mx-auto max-w-3xl px-6 text-center md:px-0">
        <Eyebrow text={CTA.eyebrow} testId="final-cta-eyebrow" />
        <h2 className="eyebrow-title-gap font-display text-3xl leading-[1.05] md:text-[2.5rem]" data-testid="final-cta-heading" style={{ color: "#201850" }}>{CTA.heading}</h2>
        <p className="mx-auto mt-4 max-w-3xl text-sm leading-7 md:text-lg" data-testid="final-cta-description" style={{ color: "rgba(32,24,80,0.72)" }}>{CTA.description}</p>
        <button type="button" onClick={() => navigate("/get-started")} data-testid="final-cta-setup-guide-button" className="btn-lift mt-8 inline-flex items-center justify-center rounded-full px-8 py-3.5 text-sm font-semibold" style={{ background: "#C69A3A", color: "#201850" }}>Setup Guide</button>
      </div>
    </section>
  );
}